import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  getPendingList,
  getPendingListById,
} from "../../../store/slices/Verification/verificationReissueSlice";
import { toast } from "react-toastify";
import { approveStockData, rejectStockData } from "./api";
import { updateConfig } from "../../../store/slices/Verification/verificationReissueSlice";
import getFilterCount from "../../../utils/getFilterCount";

const useVerificationReassign = () => {
 const data = [{ title: "Pending Queue" }];
  const state = useSelector((state) => state.verificationReissue);
  const [pendingPage, setPendingPage] = useState(1);
  const [showDetail, setShowDetail] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [gliNumber, setGliNumber] = useState("");
  const [activeCard, setActiveCard] = useState({ id: "", key: "Pending" });
  const states = state?.verificationData;
  const dispatch = useDispatch();

  const handleApproveRequest = () => {
    handleApprove();
    approveStockData(state?.pendingData?._id).then((response) => {
      if (response?.data?.status_code === 200) {
        toast.success("Stock verified successfully");
        dispatch(
          updateConfig((state) => {
            state.verificationData.Pending = [];
          })
        );
        dispatch(
          getPendingList({
            page: 1,
            per_page: 10,
          })
        );
        setShowDetail(false);
      } else {
        toast.error(response?.message);
        setShowDetail(false);
      }
    });
  };

  const handleLoadMore = (mouseHover) => {
    if (
      mouseHover === "Pending" &&
      states?.Pending?.length !== state?.PendingTotal
    ) {
      setPendingPage(pendingPage + 1);
    }
  };

  useEffect(() => {
    dispatch(
      getPendingList({
        page: pendingPage,
        per_page: 10,
      })
    );
    // eslint-disable-next-line
  }, [pendingPage]);


  useEffect(() => {
    if (isLoading) {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.pendingStatus]);

  const handleSearchInput = (e) => {
    const searchValue = e.target.value;
    dispatch(updateConfig((state) => (state.search = searchValue)));
  };

  // Inside your component
  const handleSearch = () => {
    const searchValue = state?.search;

    dispatch(
      updateConfig((state) => {
        state.verificationData.Pending = [];
      })
    );
    dispatch(
      getPendingList({
        search: searchValue,
        page: 1,
      })
    );
  };

  const handleChange = (item, key) => {
    setGliNumber(item?.gli_number);
    setActiveCard({ id: item?._id, key: "Pending" });
    setShowDetail(true);
    dispatch(getPendingListById(item?._id));
  };
  
  const handleReject = () => {
    dispatch(updateConfig((state) => (state.rejectModal = !state.rejectModal)));
  };

  const handleApprove = () => {
    dispatch(
      updateConfig((state) => (state.approveModal = !state.approveModal))
    );
  };

  const getFieldError = () => {};

  const handleRejectRequest = () => {
    handleReject();
    rejectStockData(state?.pendingData?._id).then((response) => {
      if (response?.data?.status_code === 200) {
        toast.success("Stock rejected successfully");
        dispatch(
          updateConfig((state) => {
            state.verificationData.Pending = [];
          })
        );
        dispatch(
          getPendingList({
            page: 1,
            per_page: 10,
          })
        );
        setShowDetail(false);
      } else {
        toast.error(response?.message);
        setShowDetail(false);
      }
    });
  };

  const filterCount = useMemo(() => {
    return getFilterCount({
      from_date: state.from_date,
      to_date: state.to_date,
      item_type: state.item_type,
      shop: state.shop,
      status: state.status,
    });
  }, [state.from_date, state.to_date, state.item_type, state.shop, state.status]);

  return {
    data,
    states,
    state,
    gliNumber,
    showDetail,
    activeCard,
    filterShow,
    filterCount,
    isLoading,
    totalLength: {
      Pending: state?.PendingTotal,
    },
    apiStatus: {
      Pending: state?.pendingStatus,
    },
    handleLoadMore,
    setIsLoading,
    handleReject,
    handleApprove,
    getFieldError,
    handleSearchInput,
    handleSearch,
    setFilterShow,
    handleChange,
    setShowDetail,
    handleApproveRequest,
    handleRejectRequest,
  };
};

export default useVerificationReassign;
